module.exports = __webpack_public_path__ + "static/media/icono_hora.bd17a3d4.svg";